import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ReservationComplete } from '../../components/ReservationComplete';

export const StudyCafeReservationComplete: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();

    const { seatName, time } = location.state || {
        seatName: '4',
        time: '09:00 ~ 10:00'
    };

    const description = (
        <>
            <span className="highlight">{time}</span>, {' '}
            <span className="highlight">{seatName}번</span> 좌석 예약이 완료되었습니다.
        </>
    );

    const startTime = time.split('~')[0].trim();
    const instruction = (
        <>
            <strong>{startTime}</strong> 전후로 스터디카페 앞 키오스크에서<br />
            <strong>'예약 내역 확인 &gt; 입장'</strong> 을 클릭한 후 입장해주세요
        </>
    );

    const handleMain = () => {
        navigate('/selection');
    };

    const handleLogout = async () => {
        await logout();
    };

    return (
        <ReservationComplete
            title="스터디카페 예약 완료"
            description={description}
            instruction={instruction}
            onMain={handleMain}
            onLogout={handleLogout}
        />
    );
};
